//@flow
import * as React from 'react';
import { Field, reduxForm, formValueSelector,change } from 'redux-form';
import { connect } from 'react-redux';

import ContainerRowSpace from '@lesofi/phoenix-react-js/lib/ContainerRowSpace'
import ContainerRowReduxTextField from '@lesofi/phoenix-react-js/lib/ContainerRowReduxTextField'
import ContainerRowReduxReadonlyTextAndOverrideField from '../ProjectDemeter/common/ContainerRowReduxReadonlyTextAndOverrideField'
import ContainerRowReduxHideTextFieldIfOverride from '../ProjectDemeter/common/ContainerRowReduxHideTextFieldIfOverride'

import * as actions from '../../redux/athena/actions';

const customStyles = {
    textFieldStyle: {
        width: '70%',
        paddingBottom: '10px'
    }
}

const cancelButtonOnClick=(e,props)=>{
    e.preventDefault();
    props.cancelAddEditLineItemForm();
}

const refreshLineTotal=(props)=>{
    const { itemQty,itemPrice } = props;
    let itemTotal=0
    if (itemQty && itemPrice){
        itemTotal=itemQty * itemPrice
    }
    props.changeFieldValue('itemTotal',itemTotal)
}

const refreshLineQtyForLineTotal=(e,props)=>{
    const { itemPrice } = props;
    let lineTotal = 0
    if (e.target.value && itemPrice){
        lineTotal = e.target.value * itemPrice
    }
    props.changeFieldValue('itemTotal',lineTotal)
}

const isOverrideLineQty=(e,props)=>{
    if (e.target.checked){
        props.changeFieldValue('itemQty',null)
        refreshLineQtyForLineTotal(e,props)
    }
}

const itemPriceOnChange=(e,props)=>{
    const { demeter,itemQty } = props;
    
    let itemTotal=0
    if (itemQty && e.target.value){
        itemTotal=itemQty * e.target.value
    }
    props.changeFieldValue('itemTotal',itemTotal)
}

const isOverrideNaItemPriceOnChange=(e,props)=>{
    if (e.target.checked){
        props.changeFieldValue('itemPrice',null)
        itemPriceOnChange(e,props)
    }
}

const SaveAndCancelButtons=props=>(
    <div className='row'>
        <div className="col-sm">
            <button className="btn btn-outline-primary" type="submit" disabled={props.pristine || props.submitting}>
                Save
            </button>
            &nbsp;&nbsp;&nbsp;
            <button className="btn btn-outline-secondary" type="button" onClick={(e)=>cancelButtonOnClick(e,props)}>
                Cancel
            </button>
        </div>
    </div>
)

const Title=props=>(
    <div className='row'>
        <div className='col-sm'>
            <h5>Add/Edit Line Item</h5>
        </div>
    </div>
)

const AddEditLineItemForm = props => {
    const { handleSubmit,pristine,submitting, initialValues,isOverrideItemTotal,isOverrideNaItemQty,isOverrideNaItemPrice  } = props;
    
    return (
          <div className='container'>
            <ContainerRowSpace /> 
            <ContainerRowSpace /> 
            <Title />
            <form onSubmit={handleSubmit} >
                <ContainerRowReduxTextField field={'itemDesc'} label={"Line's Description"} customStyle={customStyles.textFieldStyle}/>
                <ContainerRowReduxHideTextFieldIfOverride 
                    textField={'itemQty'} textLabel={"Line's Quantity"} textType={'number'}
                    checkboxField={'isOverrideNaItemQty'} checkboxLabel={"Line's Quantity not available in Document"}
                    isOverride={isOverrideNaItemQty} textOnChangeFunc={refreshLineQtyForLineTotal} 
                    checkboxOnChangeFunc={isOverrideLineQty} parentProps={props}
                />
                <ContainerRowReduxHideTextFieldIfOverride 
                    textField={'itemPrice'} textLabel={"Line's Rate"} textType={'number'}
                    checkboxField={'isOverrideNaItemPrice'} checkboxLabel={"Line's Rate not available in Document"}
                    isOverride={isOverrideNaItemPrice} textOnChangeFunc={itemPriceOnChange} 
                    checkboxOnChangeFunc={isOverrideNaItemPriceOnChange} parentProps={props}
                />
                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'itemTotal'} textLabel={"Line's Total"} textType={'number'}
                    checkboxField={'isOverrideItemTotal'} checkboxLabel={'Override this field'}
                    isOverride={isOverrideItemTotal} notOverrideFunc={refreshLineTotal} 
                    parentProps={props}
                />
                <SaveAndCancelButtons {...props}/>
            </form>
            <ContainerRowSpace /> 
          </div>  
        
    )
}

const validate = (values,props) => {
    const errors = {};
    const { isOverrideItemTotal,demeter }=props;
    
    let requiredFields = [
        'itemDesc',
        'itemTotal'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required'
        }
    })

    return errors;
}

const submit = (values, dispatch, props) => {
    const { jwt,taskAcceptedInfoId,athena } = props;
    let newLineItem=values;
    const { lineItem } = athena
    
    if (lineItem && lineItem.id){
        props.updateLineItem(jwt,values,lineItem.id);
    }else{
        props.createNewLineItem(jwt,newLineItem,taskAcceptedInfoId);
    }
}

const form='athenaAddEditLineItemForm'

const AddEditLineItemReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submit,
})(AddEditLineItemForm)

const selector = formValueSelector(form)

const mapStateToProps:any = (state, ownProps) => {
    return {
        athena: state.athena,
        isOverrideItemTotal: selector(state, 'isOverrideItemTotal'),
        isOverrideNaItemQty: selector(state, 'isOverrideNaItemQty'),
        isOverrideNaItemPrice: selector(state, 'isOverrideNaItemPrice'),
        itemTotal: selector(state, 'itemTotal'),
        itemQty: selector(state, 'itemQty'),
        itemPrice: selector(state, 'itemPrice'),
        initialValues: state.athena.lineItem
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      createNewLineItem: (jwt,newLineItem,taskAcceptedInfoId) => {
        dispatch(actions.createNewLineItem(jwt,newLineItem,taskAcceptedInfoId))  
      },
      updateLineItem: (jwt,updateLineItem,id) => {
        dispatch(actions.updateLineItem(jwt,updateLineItem,id))  
      },
      cancelAddEditLineItemForm: () => {
        dispatch(actions.cancelAddEditLineItemForm())  
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddEditLineItemReduxForm);


// WEBPACK FOOTER //
// ./src/views/projectAthena/AddLineItemForm.js